import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Text({
  type = 'default',
  theme = 'default',
  align = null,
  children = null,
  className = '',
  ...otherProps
}) {
  const textClassNames = classNames(
    'ws-text',
    `ws-text--type-${type}`,
    `ws-text--theme-${theme}`,
    {
      [`ws-text--align-${align}`]: Boolean(align),
    },
    className
  );

  return (
    <span className={textClassNames} {...otherProps}>
      {children}
    </span>
  );
}

Text.propTypes = {
  type: PropTypes.oneOf([
    'heading-1',
    'heading-4',
    'heading-5',
    'heading-6',
    'default',
    'regular',
    'annotation',
  ]),
  theme: PropTypes.oneOf(['primary', 'default', 'grey', 'light-grey', 'cta']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Text;
